import React from 'react';
import { useSWRConfig } from "swr";
import { api, PortalContext } from '@portal/arq-portal-core';
import { TextField, Button } from '@material-ui/core';
import { Comentario } from './Comentario';

export function DetalleElemento(props: any): JSX.Element {

    const likeElement = () => {

        let jsonLike = {
            WallElementId: elemento.WallElementId,
            Title: elemento.User.UserName,
            Body: elemento.ShortBody,
            AllowComments: true,
            Type: "LIKE"
        };
    
        api.post('/be/piupointcreateordeletelike/', {"Entrada": {"json": JSON.stringify(jsonLike),"cia": cia}}).then(() => {
            canLike?setNlikes(nLikes + 1): setNlikes(nLikes - 1);
            setCanLike(!canLike);
        });
    };

    const deleteElement = () => {

        let jsonLike = {
            ContentId: elemento.WallElementId
        };
    
        api.post('/be/piupointdeletewallelement/', {"Entrada": {"json": JSON.stringify(jsonLike),"cia": cia}}).then(() => {
            mutate(["getwallelements"]);
            doflip();
        });
    };

    const publishComment = () => {
        let jsonNew = {
            WallElementId: elemento.WallElementId,
            Title: "",
            Body: commentValue,
            AllowComments: true,
            Type: "COMMENT",
            CommentBody: commentValue
        };
    
        api.post('/be/piupointcreatewallcomment/', {"Entrada": {"json": JSON.stringify(jsonNew),"cia": cia}}).then(() => {
            mutate(["getwallelements"]);
            setCommentValue('');
        });
    };
    
    const handleComChange = (event: any) => {
        setCommentValue(event.target.value);
    };

    const { mutate } = useSWRConfig();
    const { elemento, doflip , selectedcom} = props;
    const [comments, setComments] = React.useState([]);
    const [commentValue, setCommentValue] = React.useState('');
    const [canLike, setCanLike] = React.useState(elemento.CanLike);
    const [nLikes, setNlikes] = React.useState(elemento?.Likes? elemento.Likes.length : 0);
    const { ciaGestiona } = React.useContext(PortalContext);

    var urlParams = new URLSearchParams(window.location.search);
    var ciaUrl = urlParams.get('cia');
    let cia = (ciaUrl === 'SCO' || ciaUrl === 'SBI' || ciaUrl === 'SPU') ? ciaUrl : ciaGestiona;

    React.useEffect(()=>{
        setCanLike(elemento?.CanLike);
        setNlikes(elemento && elemento.Likes ? elemento.Likes.length : 0);
        updateComments();
        //setComments(elemento && elemento.WallComments? elemento.WallComments:[]);
    },[elemento]);


    const updateComments = () => {
        api.post('/be/piupointgetwallcomments/',{"Entrada":{"cia": cia,"page":"1","pageSize":elemento.WallCommentsCount,"communityId": selectedcom,"wallContentId": elemento.WallElementId,"isMockup":false}}).then((data) => {
            setComments(data?.Salida?.response?JSON.parse(data.Salida.response):[]);
        });
    };

    const getTimeDiff = (CreationDate: string) => {

        let today = new Date();
        let created = new Date(CreationDate + 'Z');
        let hours = 0;
        let minutes = 0;
        let days = 0;
        let month = 0;
        let years = 0;

        const timeDiff = today.getTime() - created.getTime();
        minutes = Math.floor(timeDiff / (1000 * 60));
        hours = Math.floor(timeDiff / (1000 * 60 * 60));
        days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        month = (today.getMonth() + 1) - (created.getMonth() + 1) + (12 * (today.getFullYear() - created.getFullYear()));
        years = today.getFullYear() - created.getFullYear();

        if (minutes < 60) {
            return ` ${minutes === 1 ? 'un' : `${minutes}`} minuto${minutes === 1 ? '' : 's'}`;
        } else if (hours < 24) {
            return ` ${hours === 1 ? 'una' : `${hours}`} hora${hours === 1 ? '' : 's'}`;
        } else if (days < 30) {
            return ` ${days === 1 ? 'un' : `${days}`} día${days === 1 ? '' : 's'}`;
        } else if (month < 12) {
            return ` ${month === 1 ? 'un' : `${month}`} mes${month === 1 ? '' : 'es'}`;
        } else {
            return ` ${years === 1 ? 'un' : `${years}`} año${years === 1 ? '' : 's'}`;
        }
    }
    
    return (
        <div className="detalleElemento">
            <div className="detalleContent">
                <div className="elemHeader">
                    <div className="time">hace 
                        {getTimeDiff(elemento?.CreationDate)}
                    </div>
                    <div className="actions">
                        <i onClick={likeElement} className={`icon-pro-like ${!canLike ? `is-liked` : ``}`}></i>
                        <span className="inline">({nLikes})</span>
                        {elemento?.CanComment && 
                            <div className="likeDiv">
                                <i className="icon-chat"></i>
                                <span className="inline">
                                    ({elemento?.WallCommentsCount})
                                </span>
                            </div>
                        }
                        {elemento?.CanDelete && <i onClick={deleteElement} className="icon-papelera"></i>}
                    </div>
                </div>
                
                <div className="comment">{elemento?.ShortBody}</div>
                <div className="user">Publicado por <span>{elemento?.User.UserName} ({elemento?.User.JobTitle})</span></div>
           
            </div>

            <div className="indent">                   
                
                <div className="scrollCom">
                    {comments && comments.map((comment: any, i:any) => {                
                        return (<Comentario key={i} elemento={comment} />)
                    })}
                </div>

                {elemento.CanComment &&                
                    <div className="contentReplyForum">
                        <TextField {...props} id="entrada" placeholder="Escribe una respuesta..." variant="outlined" size="small"
                            className="inputReplyForum"
                            value={commentValue}
                            onChange={handleComChange}
                            multiline
                            inputProps={{style: {fontSize: 12}}} 
                            InputLabelProps={{style: {fontSize: 12}}} 
                        />
                        <Button disabled={commentValue === ''} variant="text" onClick={publishComment} className={`publicarComentario ${commentValue === '' ? `disabled` : ``}`}>
                            Publicar
                        </Button>
                    </div>
                }
            </div>
        </div>
    )
}